<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    newGroup(group) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/groups/`, group, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updateGroup(group) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/groups/${group.id}`, group, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updateGroupsPosition(orderedGroupsIds) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/groups/position`, {orderedGroupsIds}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },   

    deleteGroup(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/groups/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    getGroups() {
      return this.$http.get(`${VUE_APP_API_HOST}/groups`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(
        (res) => res.body.groups || [],
        (err) => err
      )
    }
  }
}
</script>
